var _PremiumTrialBannerSk;
import { PremiumTrialBannerSkeleton } from "../../components/PremiumTrialBanner";
import Loadable from "../../../../Loadable";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyPremiumTrialLayout = function LazyPremiumTrialLayout() {
  return /*#__PURE__*/_jsx(Loadable, {
    Loader: _PremiumTrialBannerSk || (_PremiumTrialBannerSk = /*#__PURE__*/_jsx(PremiumTrialBannerSkeleton, {})),
    module: function module() {
      return import(/* webpackChunkName: "learn-last-activity-premium-trial" */"./PremiumTrialLayout");
    }
  });
};
export default LazyPremiumTrialLayout;